import { Column, ColumnConfig } from '@ant-design/charts';
import numeral from 'numeral';

interface Props {
    lngTotalCost: number;
    dieselTotalCost: number;
}

export function TCOBarChartTotalCost(props: Props) {
    const data = [
        {
            type: 'Diesel',
            cost: props.dieselTotalCost
        },
        {
            type: 'LNG',
            cost: props.lngTotalCost
        }
    ];
    const config: ColumnConfig = {
        data: data,
        xField: 'type',
        yField: 'cost',
        label: {
            position: 'middle',
            style: {
                fill: '#000000'
            }
        },
        color: function color(_ref) {
            var type = _ref.type;
            if (type === 'LNG') {
                return '#fbd22e';
            }
            return '#588aee';
        },
        xAxis: {
            label: {
                autoHide: true,
                autoRotate: false
            }
        },
        meta: {
            cost: {
                formatter: function formatter(val) {
                    return ''.concat(numeral(val).format('0,0.00'), ' €');
                }
            }
        }
    };
    return <Column {...config} />;
}
